import { ServiceProvider } from '@cherrypulp/trunk';
import axios from 'axios';

export default class AxiosServiceProvider extends ServiceProvider {
    register() {
        if ( this.app.get( 'config' ).has( 'axios' ) ) {
            axios.defaults.headers.common = this.app.get( 'config' ).get( 'axios' ).common;
        }

        /**
         * method helper for make POST request with WordPress
         *
         * usage:
         * axios.wppost( 'your_action_name', { name: 'John Doe', foo: 'bar' } ).then( ( response ) => response.data );
         */
        Object.defineProperty(axios, 'wppost', { value: function ( action, data = {} ) {
                const params = new FormData();
                params.append( 'action', action );

                for ( let key in data ) {
                    params.append( key, data[ key ] );
                }

                return this.post( window.ajaxurl, params );
            } });

        /**
         * method helper for make GET request with WordPress
         *
         * usage:
         * axios.wpget( 'your_action_name', { name: 'John Doe', foo: 'bar' } ).then( ( response ) => response.data );
         */
        Object.defineProperty(axios, 'wpget', { value: function ( action, data = {} ) {
                const params = new URLSearchParams();
                params.append( 'action', action );

                for ( let key in data ) {
                    params.append( key, data[ key ] );
                }

                return this.get( window.ajaxurl, params );
            } });

        this.app.bind('axios', () => {
            return axios;
        } );
    }
}
